module.exports = __webpack_public_path__ + "sad.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/sad.png
// module id = 2193
// module chunks = 13